var window=global;var $CLJS=require("./cljs_env.js");
'use strict';$CLJS.ut=require("ttag");module.exports=$CLJS.ut;